import { render, staticRenderFns } from "./view-digital-currency.vue?vue&type=template&id=3c2732b9&scoped=true&"
import script from "./view-digital-currency.vue?vue&type=script&lang=js&"
export * from "./view-digital-currency.vue?vue&type=script&lang=js&"
import style0 from "./view-digital-currency.vue?vue&type=style&index=0&id=3c2732b9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2732b9",
  null
  
)

export default component.exports